import { CheckCircle2 } from "lucide-react";

const ABOUT_IMG =
  "https://customer-assets.emergentagent.com/job_foot-health-pro-2/artifacts/hv7ap2yu_IMG_1950.jpeg";

const PROMISES = [
  "We listen first — every patient is unique.",
  "Treatments tailored specifically to you.",
  "Focus on prevention, comfort and dignity.",
  "Education and advice for long-term foot health.",
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="lfc-section relative overflow-hidden">
      <div className="absolute -bottom-32 left-0 w-[480px] h-[480px] rounded-full bg-[#7B46D9]/15 blur-[140px] pointer-events-none" />

      <div className="lfc-container relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-6 order-2 lg:order-1">
            <div className="relative">
              <div className="absolute -top-8 -left-8 w-40 h-40 rounded-full bg-[#2BB8B4]/30 blur-3xl" />
              <div className="relative rounded-[2rem] overflow-hidden border border-[#4A2D7A] bg-[#2D1456]">
                <img
                  src={ABOUT_IMG}
                  alt="Compassionate elderly home care"
                  className="w-full h-[420px] lg:h-[520px] object-cover opacity-95 lfc-kenburns-alt"
                  data-testid="about-image"
                />
                <div className="absolute inset-0 bg-gradient-to-tl from-[#1B0B3A]/55 via-transparent to-transparent pointer-events-none" />
              </div>
              <div className="absolute -bottom-6 -right-6 lfc-card p-5 max-w-[280px] hidden md:block">
                <div className="text-[12px] uppercase tracking-[0.22em] text-[#5FE6E0] font-medium">
                  Our promise
                </div>
                <div className="mt-2 text-[15px] text-white leading-snug" style={{ fontFamily: "Outfit" }}>
                  Helping you stay active, comfortable and confident — at every stage of life.
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-6 order-1 lg:order-2">
            <div className="lfc-eyebrow mb-4">Patient-centred care</div>
            <h2 className="lfc-h2">
              Care that treats the person, <br className="hidden md:block" />
              not just the feet.
            </h2>
            <p className="mt-6 text-lg text-[#C2B4E6] leading-relaxed">
              We understand that travelling to appointments can be difficult due to mobility issues,
              busy schedules or medical conditions. Our mobile clinic exists to make high-quality
              foot care accessible, convenient, and stress-free — all while maintaining the highest
              clinical standards.
            </p>

            <ul className="mt-8 space-y-4">
              {PROMISES.map((p, i) => (
                <li
                  key={p}
                  data-testid={`promise-${i}`}
                  className="flex items-start gap-3 text-[16px] text-[#E5DEFA]"
                >
                  <CheckCircle2 className="w-5 h-5 text-[#2BB8B4] mt-0.5 shrink-0" strokeWidth={1.8} />
                  <span>{p}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
